import OfficeDetail from "../../../components/Office-detail"
import WithSidebar from "../../../layouts/WithSidebar"
import ListHeader from "../../../components/List-header"
import './officeDetail.css'
import { useLocation } from "react-router-dom"
import { useSearchParams } from "react-router-dom"
import ProfileFrom from "../../../components/Profile"
import { useEffect, useState } from "react"
import { ajax } from "../../../scripts/helper"
import utils from "../../../scripts/utils"
import { useSnackbar } from "notistack"


const Detail = () => {

    const { state } = useLocation()
    const [searchParams] = useSearchParams()
    const {enqueueSnackbar} = useSnackbar()
    const [officeDetail, setOfficeDetail] = useState()


    console.log(searchParams.get('type'), 'search params chie inja?', state)
    const id = searchParams.get('id')

    const type = searchParams.get('type')

    console.log(state , 'type state')

    const getOfficeDetail = async (id) => {
        console.log(id, 'id idi idi id')
        const res = await ajax({
            method: 'GET',
            url: utils.urls.officeDetail(id),
            snackbar: enqueueSnackbar,
            hasToken: true
        })

        if(!res) return

        console.log(res.data)

        setOfficeDetail(res.data)
    }

    useEffect( () => {
        console.log(state.id , 'avle aval state chie')
        if (id || type) {
            getOfficeDetail(state.id)
        }
    }, [])
    
    return (
    <WithSidebar pageTitle={"Office Detail"} breadcrumb={"Dashboard > Offices > Office Detail"} listHeaders={<ListHeader state={state} type={(id ? 'edit' : (state === 'create' ? 'create' : 'detail'))}/>} >
            <ProfileFrom data={officeDetail} type={(id ? 'edit' : (type ? 'detail' : 'create') )}/>
        </WithSidebar>
    )
}

export default Detail